import { useState } from 'react'

export function useWidgetListPipeline({ initialActive, widgets }) {
  const [activeWidget, setActiveWidget] = useState(initialActive || null)

  function handleClickNext(index) {
    const nextWidget = widgets[index + 1].name

    setActiveWidget(nextWidget)
  }

  function handleClickPrevious(index) {
    const previousWidget = widgets[index - 1].name

    setActiveWidget(previousWidget)
  }

  return {
    activeWidget,
    handleClickNext,
    handleClickPrevious,
    setActiveWidget,
  }
}
